export default "dist/images/block-divider-bar.13a6234.png";